//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import myRadioGroup from '@/components/radio-group/RadioGroup.vue'
import MyRadio from '@/components/radio/Radio.vue'
import Pie from '@/components/pie/Pie.vue'
import vote from '@/mixins/vote'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [vote, downloadImgs],
  data () {
    return {
      currentValue: '',
      rule: {
        custom: {
          imageSingleValue: {
            required: () => '请选择一个选项'
          }
        }
      }
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number
    },
    readonly: {
      type: Boolean
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    myRadioGroup,
    MyRadio,
    Pie
  },
  created () {
    // 设置投票， 在 mixins 中
		this.mountedVote()
  },
  mounted () {
    this.question.options.forEach(item => {
			this.downFile(item);
		});
    this.$validator.localize('zh_CN', this.rule);
    //已答的题挂上答案
    if (this.question.v_answer) {
      this.currentValue = this.question.v_answer.currentValue && this.question.v_answer.currentValue.join('')
    }
  },
  computed: {
    ...mapGetters(['questionnaireList']),
  },
  watch: {
    currentValue (n) {
      console.log(n);
      const param = {
        index: this.index,
        v_answered: !!n
      }
      let v_answer = {}
      // 设置当前题目已答
      this.$store.commit('setQuestionAnswered', param)
      if (!param.v_answered) {
        this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer
        })
        // 取消回调
        this.$emit('onSelectCancel')
        return
      }
      v_answer = this.getValue()
      console.log(v_answer);
      //挂本道题用户答案
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer
      })
      //把当前选中的选项传给父组件判断子题是否显示
      this.$emit('onSelectChange')    
    }
  },
  methods: {
    getValue () {
      const options = []
      let checkedOption = this.question.options.find((item) => {
        return item.tenantId == this.currentValue
      })
      options.push({
        tenantId: checkedOption.tenantId
      })
      return {
				tenantId: this.question.tenantId,
				type: 'image_single',
        options: options,
        currentValue: [this.currentValue]
			}
    },
    getDegree (percent) {
      var str = percent.replace('%','')
      return str/100 * 360
    },
    validate () {
      return this.$validator.validateAll()
    },
    // 下载文件
		downFile(item) {
			const arr = item.src.split("fileId=");
			this.ssdpRequestDtgw1({
        code: 'survey_download',
        headers: {
          's-crc-tpl-code': 'EMAP_FILE_DOWN',
          'content-type':'application/json',
        },
        params: {
          fileId: arr[1]
        },
        responseType: "blob",
        isUpload: false,
      })
      .then((res) => {
        const blobUrl = URL.createObjectURL(res.data);
        this.$set(item, "blobUrl", blobUrl);
      });
		}
  }
}
